import { api } from '../../../api';
import { ApiResponse } from '../../Utilities';
import {
    SIMDocumentTypeScheduleViewModel,
    SupplierSIMRequestViewModel,
    ValidateAccountRequestViewModel,
    ValidateAccountResponseViewModel,
    ValidateTinRequestViewModel,
    ValidateTinResponseViewModel,
} from '../../ViewModels';
import { GetSupplierSimRequestParams, SearchDocumentTypesParams } from './Params';

export class DocumentTypeApi {
    private route = '/DocumentType';

    /**
     * GET /DocumentType?companyId=…&isBuyer=… — SIM document type schedules visible to the company.
     * For suppliers, pass the supplier company id and isBuyer=false (same pattern as supplier-portal SIM settings).
     */
    public searchDocumentTypes(params: SearchDocumentTypesParams): ApiResponse<SIMDocumentTypeScheduleViewModel[]> {
        return api().get(this.route, {
            params: {
                ...params,
                isBuyer: params.isBuyer ?? false,
            },
        });
    }

    /**
     * Fetches the SIM requests targeted at a specific supplier company.
     *
     * Mirrors the legacy supplier-portal call used by the home-page SIM
     * accordion (see SIMDocumentTypesThunk.fetchSupplierSIMRequests). The
     * backend has already applied the buyer-side `SupplierSelection` /
     * inclusion / exclusion / vendor-class filtering, so the response is
     * "open SIM requests this supplier still owes."
     *
     * Note: this endpoint returns a plain array, not a PageResult.
     */
    public getSupplierSIMRequest(params: GetSupplierSimRequestParams): ApiResponse<SupplierSIMRequestViewModel[]> {
        return api().get(`${this.route}/SupplierSIMRequest`, { params });
    }

    /** POST /DocumentType/ValidateAccount — verifies ACH account/routing via Plaid. */
    public validateAccount(body: ValidateAccountRequestViewModel): ApiResponse<ValidateAccountResponseViewModel> {
        return api().post(`${this.route}/ValidateAccount`, body);
    }

    /** POST /DocumentType/ValidateTIN — verifies a TIN via Sovos. */
    public validateTin(body: ValidateTinRequestViewModel): ApiResponse<ValidateTinResponseViewModel> {
        return api().post(`${this.route}/ValidateTIN`, body);
    }
}
